import { prefixObjectValues } from '../utils';

const malpracticeTags = {
  insuranceTab: 'insurance-tab',
  claimsTab: 'claims-tab',
};

export default prefixObjectValues(malpracticeTags, 'malpractice');
